<template>
  <div>
    <LockedView v-if="!project.isPermission">
      {{ $t("projectDetail.projectPermissonsLocked") }}
    </LockedView>
    <div v-else>
      <Table
        i18n
        no-search
        :loading="getProjectPermissionsLoadingById"
        no-card
        checkable
        :checkValue="checkedList"
        @change:checkedList="checkedList = $event"
        :headers="headers"
        :items="ProjectPermissions"
      >
        <template #new-button>
          <div class="u-display-flex u-width-100% u-justify-content-flex-end">
            <ExcelExport
              :fileName="`${project.projectNo}/${
                project.model
              }-export-${$date.format(new Date())}`"
              :fields="exportFields"
              :data="checkedList.length > 0 ? checkedList : ProjectPermissions"
            >
              <template #button="{ showExcell }">
                <Button
                  @click="showExcell()"
                  variant="light-success"
                  class="u-margin-right-xsmall"
                >
                  <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
                </Button>
              </template>
            </ExcelExport>
            <Button
              v-if="getActiveUser.userInfo.role === 'Admin'"
              @click="showCreatePermission = true"
              variant="light-primary"
              class="u-margin-right-xsmall"
            >
              + {{ $t("projectDetail.createPermission") }}
            </Button>
          </div>
        </template>
        <template #authorizedUserInfo="{ item }">
          <router-link :to="`/user/${item.authorizedUserInfo.id}`">{{
            item.authorizedUserInfo.fullname
          }}</router-link>
        </template>
        <template #authorizingUserInfo="{ item }">
          <router-link :to="`/user/${item.authorizingUserInfo.id}`">{{
            item.authorizingUserInfo.fullname
          }}</router-link>
        </template>
        <template #createdDate="{ item }">
          <div>{{ $date.format(item.createdDate) }}</div>
        </template>
        <template #action="{ item }">
          <Button
            v-if="getActiveUser.userInfo.id !== item.authorizedUserInfo.id"
            size="sm"
            variant="light-danger"
            @click="REMOVE_TO(item)"
          >
            <i class="icofont-trash"></i
          ></Button>
        </template>
      </Table>
    </div>
    <Modal
      v-model="showCreatePermission"
      :title="$t('projectDetail.createPermission')"
      hide-footer
    >
      <p class="u-color-muted u-margin-bottom">
        {{ $t("projectDetail.createPermissionDescription") }}
      </p>
      <UserSearch v-model="createUserInfo"></UserSearch>
      <p class="o-alert o-alert--info u-margin-top">
        <i class="icofont-info-circle"></i>
        {{ $t("projectDetail.createPermissionDescription2") }}
      </p>
      <p class="o-alert o-alert--warning u-margin-top" v-if="!createUserInfo">
        <i class="icofont-warning"></i>
        {{ $t("projectDetail.createPermissionAlert") }}
      </p>
      <div class="u-margin-top">
        <Button
          :disabled="!createUserInfo"
          block
          variant="primary"
          @click="createPermission"
        >
          + {{ $t("common.create") }}
        </Button>
      </div>
    </Modal>
    <RemoveModal
      v-model="removePermissions.status"
      sm
      @ok="removePermission"
    ></RemoveModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Table from "../../Base/Table/index.vue";
import Button from "../../Base/Button.vue";
import ExcelExport from "../../Base/ExcelExport.vue";
import LockedView from "@/components/LockedView/index.vue";
import Modal from "@/components/Base/Modal.vue";
import UserSearch from "@/components/Searches/UserSearch.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import Requests from "@/services/Requests";
export default {
  name: "ProjectPermissions",
  components: {
    Table,
    LockedView,
    Button,
    UserSearch,
    RemoveModal,
    Modal,
    ExcelExport,
  },
  data() {
    return {
      showCreatePermission: false,
      createUserInfo: null,
      removePermissions: {
        status: false,
        item: null,
      },
      checkedList: [],
      headers: [
        {
          col: 12,
          sm: 4,
          md: 4,
          lg: 4,
          title: "projectDetail.authorizedUserInfo",
          value: "authorizedUserInfo",
        },
        {
          col: 6,
          sm: 3,
          md: 3,
          lg: 3,
          title: "projectDetail.createdAt",
          value: "createdDate",
        },
        {
          col: 6,
          sm: 3,
          md: 3,
          lg: 3,
          title: "projectDetail.authorizingUserInfo",
          value: "authorizingUserInfo",
        },
        {
          col: 6,
          sm: 1,
          md: 1,
          lg: 1,
          title: "common.action",
          value: "action",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getProjectPermissionsById",
      "getProjectPermissionsLoadingById",
      "getActiveUser",
    ]),
    ProjectPermissions() {
      return this.getProjectPermissionsById(this.project.id).items;
    },
    exportFields() {
      return {
        [this.$t("projectDetail.authorizedUserInfo")]: {
          field: "authorizedUserInfo.fullname",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("projectDetail.authorizingUserInfo")]: {
          field: "authorizingUserInfo.fullname",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("projectDetail.createdAt")]: {
          field: "createdDate",
          callback: (value) => {
            console.log(value, "date");

            return this.$date.format(value || new Date());
          },
        },
        [this.$t("project.name")]: {
          field: "project.title",
          callback: () => {
            return this.project.model;
          },
        },
      };
    },
  },
  props: {
    project: {
      required: true,
      type: Object,
    },
  },
  methods: {
    REMOVE_TO(item) {
      this.removePermissions = {
        status: true,
        item: item,
      };
    },
    async removePermission(loading) {
      loading(true);
      const response = await Requests.ProjectPermissions.Delete({
        params: { id: this.removePermissions.item.id },
      });

      if (response.message === "OK") {
        this.getProjectPermissions(true);
        this.removePermissions = {
          status: false,
          item: null,
        };
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("projectDetail.deletePermissionSuccess"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async getProjectPermissions(force = false) {
      if (this.project.isPermission)
        await this.$store.dispatch("getProjectPermissionsById", {
          projectId: this.project.id,
          force,
        });
    },
    async createPermission(e, loading) {
      loading(true);
      const response = await Requests.ProjectPermissions.Create({
        authorizedUserId: this.createUserInfo.id,
        projectId: this.project.id,
      });
      console.log(response, "respnsee");

      if (response.message === "OK") {
        this.getProjectPermissions(true);
        this.showCreatePermission = false;
        this.createUserInfo = null;
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("projectDetail.createPermissionSuccess"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
  mounted() {
    this.getProjectPermissions();
  },
};
</script>

<style></style>
